<template>
    <div class="screenshots-area bg-black-color  pt-75 " :class="pt" v-if="app_screens?.length > 0">
        <div class="container">
            <div class="section-title color-white">
                 <div class="big-title"> 
                <span class="sub-title-shadow text-capitalize" style="opacity: 0.1;">Screen</span>
                <span class="sub-title text-uppercase  ">APP SCREEN</span>
                <h2>Beautifully Crafted All App Screenshots</h2>
            </div>
                 </div>
            <div class="screenshots-slides">
                <carousel
                    :wrap-around="true"
                    :autoplay="3000"
                    :settings='settings'
                    :breakpoints='breakpoints'>
                    <slide 
                        v-for="slide in app_screens" 
                        :key="slide.url">
                        <div class="single-screenshot-item">
                            <img :src="$backendUrl+slide?.url" :alt="slide?.alternativeText || 'App Screenshot'" loading="lazy">
                        </div>
                    </slide>
                    
                    <template #addons>
                        <navigation>
                            <template #next>
                                <i class='ri-arrow-right-s-line'></i>
                            </template>
                            <template #prev>
                                <i class='ri-arrow-left-s-line'></i>
                            </template>
                        </navigation>
                    </template>
                </carousel>
            </div>
        </div>
    </div>
</template>

<style>
/* span.sub-title-shadow {
    opacity: 0.1;
} */
</style>
<script>
import { defineComponent } from 'vue';
import { Carousel, Slide, Navigation  } from 'vue3-carousel';

import 'vue3-carousel/dist/carousel.css';

export default defineComponent ({
    name: 'AppScreens',
    components: {
        Carousel,
        Slide,
        Navigation,
    },
    props: {
        app_screens: {
            type: [], // Set the prop type to be Any
            required: true,
            
        },

        pt: {
      type: String, // or whatever type you're expecting, maybe Number
      default: 'pb-50',
    },
    },
    data: () => ({
        settings: {
            itemsToShow: 1,
            snapAlign: 'center',
        },
        breakpoints: {
            0: {
                itemsToShow: 1,
                snapAlign: 'left',
			},
            576: {
                itemsToShow: 2,
                snapAlign: 'center',
            },
            768: {
                itemsToShow: 3,
                snapAlign: 'center',
            },
            992: {
                itemsToShow: 4,
                snapAlign: 'center',
            },
            1200: {
                itemsToShow: 5,
                snapAlign: 'center',
            },
        },

    }),
})
</script>